import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'opacity',
  templateUrl: './opacity.component.html',
  styleUrls: ['./opacity.component.scss']
})
export class OpacityComponent implements OnInit {

  @Input() showOpacity: boolean = true;
  constructor() { }

  ngOnInit() {
  }

}
